module.exports = __webpack_public_path__ + "static/media/3.8752aa3d.jpg";